import { type InfiniteData, useInfiniteQuery } from '@tanstack/react-query';
import {
  type GetIssueActionCount200Response,
  useApi,
  IssueSLAsFilteringDtoOptions,
} from '@issuemanager/api-client';
import { ExtendedAxiosError } from '@issuemanager/apps/client/hooks';

export type UseInfiniteIssueActionCountParamsObject = {
  page?: number;
  limit?: number;
  filter?: IssueSLAsFilteringDtoOptions;
};

export interface UseInfiniteIssueActionCountParams {
  params?: UseInfiniteIssueActionCountParamsObject;
  enabled?: boolean;
}

export function useInfiniteIssueActionCount({
  params = {},
  enabled = true,
}: UseInfiniteIssueActionCountParams) {
  const { page = 0, limit = 10, filter } = params;

  const api = useApi();

  const queryKey = ['issue-action-count', page, limit, filter, enabled];

  return useInfiniteQuery<
    GetIssueActionCount200Response,
    ExtendedAxiosError,
    InfiniteData<GetIssueActionCount200Response>,
    typeof queryKey,
    number
  >({
    queryKey,
    queryFn: ({ pageParam }) =>
      api.issueActionCountApi
        .getIssueActionCount(filter, pageParam, limit)
        .then((r) => r.data),
    enabled,
    initialPageParam: page,
    getNextPageParam: (lastPage) =>
      lastPage.meta.hasNextPage ? lastPage.meta.page + 1 : undefined,
  });
}
